import { List } from 'immutable'
import IconSVG from 'svg-inline-react'

import plusIconSrc from '!svg-inline?removeTags=true!images/svg/plus.svg'
import closeIconSrc from '!svg-inline?removeTags=true!images/svg/close.svg'

export const NumberInput = ({ min = 0, max, onChange, value, className }) =>
<input
  className={className}
  type="number"
  min={min}
  max={max}
  value={value}
  onChange={event => onChange(event.target.value)}
  placeholder="Enter value"
/>

export const StringsInput = ({ onChange, value, className, placeholder = 'Enter Value' }) =>
<div className={className}>
  <div>
    {(value || List.of('')).map((innerValue, index) =>
      <div className="flex strings-input" style={{ marginBottom: 10 }} key={index}>
        <input
          type="text"
          value={innerValue}
          onChange={event => onChange(value.set(index, event.target.value))}
          placeholder={placeholder}
        />
        {index === 0
          ? <IconSVG src={plusIconSrc} onClick={() => onChange(value.push(''))} />
          : <IconSVG src={closeIconSrc} onClick={() => onChange(value.delete(index))} />}
      </div>
    )}
  </div>
</div>



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/Inputs.js